module.exports = __webpack_public_path__ + "img/icon_map_car_c.677d8ce5.png";